import * as Sentry from "@sentry/browser";
import { Severity } from "@sentry/browser";

export const sendLog = (message: string) => {
    // Sentry.configureScope(function(scope) {
    //     scope.setTag("page_locale", "de-at");
    // });
    Sentry.captureMessage(message);
};

export const setUser = (
    user: {
        id: string;
        password: string;
        userType: string;
        token: string;
    } | null
) => {
    Sentry.configureScope(function (scope) {
        scope.setUser(user);
    });
};

export const captureError = (
    error: any,
    errorTag: "network" | "normal" = "normal",
    params?: any
) => {
    Sentry.withScope(scope => {
        scope.setTag("Error Type", errorTag);
        params && scope.setExtra("Params", params);
        Sentry.captureException(error);
    });
};

export const addBreadcrumb = (
    category: string,
    message: string,
    level: Severity
) => {
    Sentry.addBreadcrumb({ category, message, level });
};
